import { Link } from "@tanstack/react-router";

const tab =
  "rounded-md px-3 py-1.5 text-sm text-text hover:bg-surface-2 aria-[current=page]:bg-surface-2 aria-[current=page]:font-semibold";

/** Tabs between the settings pages. */
export function SettingsNav() {
  return (
    <nav aria-label="Settings" className="-mt-3 flex flex-wrap gap-1">
      <Link to="/settings/profile" className={tab}>
        Profile
      </Link>
      <Link to="/settings/workspaces" className={tab} activeOptions={{ exact: false }}>
        Workspaces
      </Link>
      <Link to="/settings/accounts" className={tab}>
        Mail accounts
      </Link>
      <Link to="/settings/notifications" className={tab}>
        Notifications
      </Link>
      <Link to="/settings/senders" className={tab}>
        Senders
      </Link>
      <Link to="/settings/rules" className={tab}>
        Rules
      </Link>
      <Link to="/settings/security" className={tab}>
        Security
      </Link>
      <Link to="/settings/activity" className={tab}>
        Activity
      </Link>
    </nav>
  );
}
